"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCurrentUserToGroup = exports.createOrUpdateGroup = exports.logEventWithGroups = exports.logEvent = void 0;
const setupAmplitude_1 = __importDefault(require("./setupAmplitude"));
const createLogEventFunction = (amplitudeSetupFn = setupAmplitude_1.default) => {
    /**
     * @deprecated Please refer to this README {@link https://github.com/cultureamp/node-packages/tree/master/packages/amplitude#new-usage-more-detailed-guidance-will-be-updated-here}
     * Log an event with eventType and eventProperties.
     * https://help.amplitude.com/hc/en-us/articles/115002889587#methods
     */
    const logEvent = (eventType, eventProperties) => __awaiter(void 0, void 0, void 0, function* () {
        const amplitude = yield amplitudeSetupFn();
        if (amplitude === null || amplitude === void 0 ? void 0 : amplitude.success) {
            amplitude.value.logEvent(eventType, eventProperties);
            amplitude.value.inspector.trackSchemaFromEvent(eventType, eventProperties !== null && eventProperties !== void 0 ? eventProperties : {});
        }
        return;
    });
    /**
     * @deprecated Please refer to this README {@link https://github.com/cultureamp/node-packages/tree/master/packages/amplitude#new-usage-more-detailed-guidance-will-be-updated-here}
     * Log an event with eventType, eventProperties, and eventGroups.
     * Experimental: Check with team Analytics Capability before use.
     */
    const logEventWithGroups = (eventType, eventProperties, eventGroups) => __awaiter(void 0, void 0, void 0, function* () {
        const amplitude = yield amplitudeSetupFn();
        if (amplitude === null || amplitude === void 0 ? void 0 : amplitude.success) {
            amplitude.value.logEventWithGroups(eventType, eventProperties, eventGroups);
            amplitude.value.inspector.trackSchemaFromEvent(eventType, eventProperties !== null && eventProperties !== void 0 ? eventProperties : {});
        }
        return;
    });
    /**
     * @deprecated Please refer to this README {@link https://github.com/cultureamp/node-packages/tree/master/packages/amplitude#new-usage-more-detailed-guidance-will-be-updated-here}
     */
    const createOrUpdateGroup = (type, id, properties) => __awaiter(void 0, void 0, void 0, function* () {
        const amplitude = yield amplitudeSetupFn();
        if (amplitude === null || amplitude === void 0 ? void 0 : amplitude.success) {
            const identifyObj = new amplitude.value.Identify();
            if (!!properties) {
                Object.keys(properties).forEach((propKey) => {
                    identifyObj.set(propKey, properties[propKey]);
                });
            }
            // @ts-ignore
            amplitude.value.groupIdentify(type, id, identifyObj);
        }
    });
    const addCurrentUserToGroup = (type, id, properties) => __awaiter(void 0, void 0, void 0, function* () {
        const amplitude = yield amplitudeSetupFn();
        if (amplitude === null || amplitude === void 0 ? void 0 : amplitude.success) {
            amplitude.value.setGroup(type, id);
            const identifyObj = new amplitude.value.Identify();
            if (!!properties) {
                Object.keys(properties).forEach((propKey) => {
                    identifyObj.set(propKey, properties[propKey]);
                });
            }
            // @ts-ignore
            amplitude.value.groupIdentify(type, id, identifyObj);
        }
    });
    return {
        logEvent,
        logEventWithGroups,
        createOrUpdateGroup,
        addCurrentUserToGroup,
    };
};
exports.default = createLogEventFunction;
_a = createLogEventFunction(), exports.logEvent = _a.logEvent, exports.logEventWithGroups = _a.logEventWithGroups, exports.createOrUpdateGroup = _a.createOrUpdateGroup, exports.addCurrentUserToGroup = _a.addCurrentUserToGroup;
//# sourceMappingURL=createLogEventFunctions.js.map